<template>
  <div>
    <gSwiper :arr="arr" :maxH="'inherit'"></gSwiper>
    <div class="register">
      <Row :gutter="10" class="top">
        <Col span="18">
        <div class="title disFlex">
          <div style="color: #1e88e5; line-height: 22px;">CHCC2025第26届全国医院建设大会暨国际医院建设、装备及管理展览会</div>
        </div>
        </Col>
        <Col span="6" class="f-tar">
        <Button shape="circle" style="margin-left:10px"
          @click="$router.push(`/ex-register-en/register-mobile`)">English</Button>
        </Col>
      </Row>
      <registerForm ref="registerForm"></registerForm>
      <!-- <registerAddr ref="registerAddr"></registerAddr> -->

      <div class="tip-info">

      </div>

      <div class="f-tac submit-btn">
        <Button type="primary" size="large" long @click="handleSubmit" :loading="loading">提交申请</Button>
      </div>

    </div>
  </div>
</template>

<script>
import gSwiper from "@components/gSwiper/gSwiper2.vue";
import { mapActions } from "vuex";
import registerForm from "./components/mobile-register-form.vue";
import registerAddr from "./components/mobile-register-addr.vue";
export default {
  name: 'register',
  components: {
    registerForm,
    registerAddr,
    gSwiper,
  },
  data() {
    return {
      loading: false,
      //   arr: [{ id: 1, path: require('../../../assets/img/banner.png') }],
      arr: [{ id: 1, path: 'https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202502/7abe52d37713459b92ccdb6f4d1b23a2.jpg' }],

    };
  },
  methods: {
    ...mapActions({
      getApplyCompanyRoastCreate: 'registerdModule/getApplyCompanyRoastCreate', // 新增展会接口
    }),
    async handleSubmit() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let res = await this.$refs.registerForm.handleSubmit();
      this.loading = false;
      if (!res.valid) return;
      //   let res1 = await this.$refs.registerAddr.handleSubmit();
      //   console.log('registerForm', res);
      //   console.log('res1', res1);
      //   console.log('registerAddr', res2);
      let opt = {
        newCompany: { ...res.form, },
        lists: [{
          // exhibitionId: '71F993FB-03A8-4EB3-A3F0-65C9D2D665F3',
          exhibitionId: 'EFC0A7EC-B2F0-4EF6-9ED4-8114CFD528DB',
          ...res.lists[0]
        }],
        reportType: 'cn'
      };
      //   if(res1.lists.length>0){
      //             res1.lists[0].exhibitionId="916139F0-4A1E-4C53-983B-F9BCCC4897CC"
      //             opt.lists.push(res1.lists[0])
      //         }
      console.log('option', opt);
      let bool = await this.getApplyCompanyRoastCreate(opt);
      this.loading = false;
      console.log('getApplyCompanyRoastCreate', bool);
      if (bool && bool.successed) {
        let query = 'company=' + encodeURI(res.form.companyName);
        this.$router.push(`/ex-register/register-result?${query}`);
        // let query = 'company=' + encodeURI(res.form.companyName) + '&exname=' + encodeURI(res2.exhibition.name);
        // this.$router.push(`/ex-register/register-result?${query}`);
      } else {
        let errTxt = bool.msg || bool.info || "提交失败，请重新尝试！";
        if (bool.errors && bool.errors[0] && bool.errors[0].description) {
          errTxt = bool.errors[0].description;
        }
        this.$Message.error(errTxt);
      }
    },
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
  created() {
    if (this.IsPC()) {
      this.$router.push(`/ex-register/register`);
    }
    document.title = "CHCC参展报名";
  },
  mounted() { }
}

</script>

<style lang="scss" scoped>
.register {
  max-width: 1200px;
  margin: 0 auto;
  background: #f7f7f7;

  .top {
    padding: 15px;
  }

  .title {
    font-size: 15px;
    color: #333;
    font-weight: bold;
    line-height: 32px;
  }
}

.submit-btn {
  text-align: center;
  padding: 5px 15px 0;

  button {
    background-color: #1e88e5;
    font-size: 15px;
    border-color: #1e88e5;
    margin-bottom: 30px;
    height: 40px;
    color: #fff;
  }
}

.tip-info {
  margin: 25px auto;
  padding: 0 15px;
  white-space: nowrap;
  color: #666;

  p {
    font-size: 12px;
    margin-bottom: 4px;
    white-space: normal;
  }
}

.disFlex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
